module.exports = __webpack_public_path__ + "static/media/5.0d0bba9.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/majors/5.wav
// module id = I+Ol
// module chunks = 0